import React, { useEffect, useState } from "react";
import {
  Steps,
  Button,
  Input,
  Select,
  Upload,
  DatePicker,
  Typography,
  Card,
  message,
  Form,
  Modal,
  Row,
  Col,
} from "antd";
import {
  CarTwoTone,
  IdcardTwoTone,
  FileImageTwoTone,
  UploadOutlined,
} from "@ant-design/icons";
import { motion } from "framer-motion";
import colors from "../../assets/styles/colour";
import icon from "../assets/images/register.png";
import Title from "antd/es/typography/Title";
import dataService from "../../networks/api/service/dataService";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs"; // for setting date value

const { Step } = Steps;
const { Option } = Select;
const { TextArea } = Input;

const steps = [
  { title: "Driver Details", icon: <IdcardTwoTone twoToneColor="#52c41a" /> },
  {
    title: "Assign Vehicle",
    icon: <FileImageTwoTone twoToneColor="#eb2f96" />,
  },
];

const DriverRegistration = () => {
  const [currentStep, setCurrentStep] = useState(0);
   const [vehicleList, setVehicleList] = useState([]);
  const [formData, setFormData] = useState({assignedVehicle:""});
  const [selectedDriver, setSelectedVehicle] = useState(null);
const [pendingVehicle, setPendingVehicle] = useState(null);
const [showConfirmModal, setShowConfirmModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const editMode = location.state?.editMode || false;
  const driverData = location.state?.driverData || null;

  const handleNext = () => setCurrentStep((prevStep) => prevStep + 1);
  const handleBack = () => setCurrentStep((prevStep) => prevStep - 1);
  const handleFileUpload = (info, field) => {
    if (info.file.status === "done") {
      setFormData({ ...formData, [field]: info.file.originFileObj });
    }
  };
  useEffect(() => {
    if (editMode && driverData) {
      setFormData({
        driverName: driverData.driverName || "",
        driverPhoneNumber: driverData.driverPhoneNumber || "",
        driverEmail: driverData.driverEmail || "",
        driverLicenseNum: driverData.driverLicenseNum || "",
        licenceValidity: driverData.licenceValidity
          ? dayjs(driverData.licenceValidity)
          : null,
      });
    }
  }, [editMode, driverData]);
  const handleEdit = (driverData) => {
    navigate("/driver-registration", {
      state: { editMode: true, driverData },
    });
  };
  const handleSubmit = async () => {
    const payload = {
      driverName: formData.driverName,
      driverPhoneNumber: formData.driverPhoneNumber,
      driverEmail: formData.driverEmail,
      driverLicenseNum: formData.driverLicenseNum,
      licenceValidity: formData.licenceValidity?.format("YYYY-MM-DD") || "",
      assignedVehicle: formData.assignedVehicle || null
    };

    try {
      if (editMode) {
        const res = await dataService.editDriver({
          ...payload,
          id: driverData._id,
        });
        if (res.code === 200) {
          message.success("Driver updated successfully!");
          navigate ("/login/driver-management")
        } else {
          message.error("Failed to update driver. Please try again.");
        }
      } else {
        const res = await dataService.addDriver(payload);
        if (res.code === 200) {
          message.success("Driver registered successfully!");
          navigate ("/login/driver-management")
        } else {
          message.error("Failed to register driver. Please try again.");
        }
      }
      setFormData({
        driverName: "",
        driverPhoneNumber: null,
        driverEmail: "",
        driverLicenseNum: "",
        licenceValidity: "",
        assignedVehicle: "",
      })
    } catch (err) {
      console.error("Error:", err);
      message.error("An error occurred.");
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      const vehicles = await dataService.getAllVehicle();  
      setVehicleList(vehicles.data);
      
    };
  
    fetchData();
  }, []);

  const handleVehicleChange = (vehicleId) => {
    if (!vehicleId) { // If user clears the selection
      setSelectedVehicle(null);
      setFormData({ ...formData, assignedVehicle: "" });
      return;
    }
  
    const vehicle = vehicleList.find((d) => d._id === vehicleId);
  
    if (vehicle?.isAssigned) {
      setPendingVehicle(vehicle);
      setShowConfirmModal(true);
    } else {
      setSelectedVehicle(vehicleId);
      setFormData({ ...formData, assignedVehicle: vehicleId });
    }
  };
  


  
  const confirmReassign = () => {
    setSelectedVehicle(pendingVehicle._id);
      setFormData({ ...formData, assignedVehicle: pendingVehicle._id });
      setPendingVehicle(null);
      setShowConfirmModal(false);
      message.success("Driver reassigned successfully");
    };
    
    const cancelReassign = () => {
      setPendingVehicle(null);
      setShowConfirmModal(false);
    };

  return (
    <Card
      style={{
        maxWidth: 900,
        margin: "40px auto",
        padding: 20,
        borderRadius: 10,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Icon */}
        <motion.img
          src={icon}
          alt="Trip Icon"
          style={{
            width: "40px",
            height: "40px",
            marginRight: "10px", // Space between the icon and title
            animation: "bounce 4s infinite", // Add a bounce animation for fun
          }}
          // animate={{ y: [0, -5, 0] }}
          // transition={{ repeat: Infinity, duration: 1.2, ease: "easeInOut" }}
        />

        {/* Title */}
        <Title level={3} style={{ marginBottom: 20 }}>
          {editMode ? "Edit Driver" : "Driver Registration"}
        </Title>
      </motion.div>
      <Steps current={currentStep} style={{ marginBottom: 30 }}>
        {steps.map((step, index) => (
          <Step key={index} title={step.title} icon={step.icon} />
        ))}
      </Steps>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
       {currentStep === 0 && (
  <div>
    <Typography.Title level={4}>Driver Details </Typography.Title>
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Input
          placeholder="Driver Name"
          value={formData.driverName || ""}
          onChange={(e) =>
            setFormData({ ...formData, driverName: e.target.value })
          }
          style={{ width: "100%" }}
        />
      </Col>

      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Input
          placeholder="Driver Phone"
          value={formData.driverPhoneNumber || ""}
          maxLength={10}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "");
            if (value.length <= 10) {
              setFormData({ ...formData, driverPhoneNumber: value });
            }
          }}
          style={{ width: "100%" }}
        />
      </Col>

      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Input
          placeholder="Driver Email"
          value={formData.driverEmail || ""}
          onChange={(e) =>
            setFormData({ ...formData, driverEmail: e.target.value })
          }
          style={{ width: "100%" }}
        />
      </Col>

      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Input
          placeholder="Driver License Number"
          value={formData.driverLicenseNum || ""}
          onChange={(e) =>
            setFormData({ ...formData, driverLicenseNum: e.target.value })
          }
          style={{ width: "100%" }}
        />
      </Col>

      <Col xs={20} sm={12} md={10} lg={10} xl={10}>
        <Upload
          beforeUpload={() => false}
          onChange={(info) => handleFileUpload(info, "driverLicenseImage")}
        >
          <Button icon={<UploadOutlined />}>Upload Driver License</Button>
        </Upload>
      </Col>

      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <DatePicker
          style={{ width: "100%" }}
          placeholder="DL Validity"
          value={formData.licenceValidity}
          onChange={(date) =>
            setFormData({ ...formData, licenceValidity: date })
          }
        />
      </Col>
    </Row>
  </div>
)}


{currentStep === 1 && (
  <div>
    <Typography.Title level={3}>Assign Vehicle</Typography.Title>

    <Row gutter={[16, 16]}>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
      <Select
  placeholder="Select a Vehicle"
  name="vehicleId"
  allowClear // Allow clearing the selection
  style={{ width: "100%", borderRadius: "8px" }}
  value={formData.assignedVehicle || undefined} // Ensure controlled input
  onChange={handleVehicleChange}
  loading={vehicleList.length === 0}
>
  {vehicleList.map((vehicle) => (
    <Select.Option key={vehicle._id} value={vehicle._id}>
      {vehicle.makeAndModel}-{vehicle.registrationNum}
    </Select.Option>
  ))}
</Select>




      </Col>
    </Row>

    <Modal
      title="Vehicle Already Assigned"
      visible={showConfirmModal}
      onOk={confirmReassign}
      onCancel={cancelReassign}
      okText="Yes, Reassign"
      cancelText="No"
    >
      <p>
        This vehicle <b>{pendingVehicle?.makeAndModel} - {pendingVehicle?.registrationNum}</b> is already assigned.
      </p>
      <p>Do you want to reassign this vehicle to your driver?</p>
    </Modal>
  </div>
)}

      </motion.div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 30,
        }}
      >
        <Button
          disabled={currentStep === 0}
          style={{ borderColor: colors.button, color: colors.button }}
          onClick={handleBack}
        >
          Previous
        </Button>
        {currentStep < steps.length - 1 ? (
          <Button
            type="primary"
            style={{ backgroundColor: colors.button }}
            onClick={handleNext}
          >
            Next
          </Button>
        ) : (
          <Button
            type="primary"
            style={{ backgroundColor: colors.button }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        )}
      </div>
    </Card>
  );
};

export default DriverRegistration;
